export default "__VITE_ASSET__D8EFL6WG__"